import { render } from "./index.vue?vue&type=template&id=c9aaf266&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c9aaf266&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-c9aaf266"

export default script